import type { FC } from 'react';
import { Box } from '@mui/material';

import { Text } from 'ui';
import palette from 'ui/theme/palette';

export interface PointsBadgeProps {
  points: number;
  selected?: boolean;
}

export const PointsBadge: FC<PointsBadgeProps> = (props) => (
  <Box
    data-cy="points-badge"
    sx={{
      flexShrink: 0,
      px: 1,
      py: 0.25,
      borderRadius: 1,
      backgroundColor: (theme) => (props.selected ? palette.primary.screen : theme.palette.action.hover)
    }}
  >
    <Text
      content={`${props.points} pts`}
      sx={{
        whiteSpace: 'nowrap',
        fontSize: '13px',
        fontWeight: props.selected ? 700 : 400,
        color: (theme) => (props.selected ? theme.palette.primary.main : theme.palette.text.secondary)
      }}
    />
  </Box>
);
